import { Component, Inject, Input, OnInit, OnChanges, EventEmitter, Output } from "@angular/core";
import { DialogService } from "../../../../services/dialog.service";
import { DefaultValuesService } from "../../../../services/defaultvalues.service";
import { MatDialog } from "@angular/material/dialog";
import { animate, state, style, transition, trigger } from "@angular/animations";
import { KpiDetailFormComponent } from "../kpidetail-form.component";
import { MatTableDataSource } from "@angular/material/table";
import { OnDestroy } from "@angular/core";
import { Subject } from "rxjs";
import { Utils } from "../../../../utils/utils";
import { SelectionModel } from "@angular/cdk/collections";
import { FilterUtils } from "../../shared-components/filter/filter-utils";


@Component({
    selector: "oplmonthlykpimanagement-list",
    templateUrl: './oplmonthlykpimanagement-list.component.html',
    styleUrls: ['./oplmonthlykpimanagement-list.component.less',
        '../../../../style/new-generic-styles.component.less'
        , '../../../../style/mat-table.component.less'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
            state('expanded', style({ height: '*', })),
            transition('expanded => collapsed', [animate('0ms cubic-bezier(0.4, 0.0, 0.2, 1)')]),
        ]),
    ],
    standalone: false
})

export class OPLMonthlyKPIManagementListComponent implements OnInit, OnChanges, OnDestroy {
        private truncateDecimals(num: number, digits: number) {
            const factor = Math.pow(10, digits);
            return Math.trunc(num * factor) / factor;
        }
    @Input('list') list: KpiManagement[] = [];
    @Input('filter') filter: string = ''

    @Input('isEditModeEnabled') isEditModeEnabled: boolean = false;
    @Input('isApprovalModeEnabled') isApprovalModeEnabled: boolean = false;
    @Input('auxFilterPredicate') auxFilterPredicate!: (filters: string, data: any, parentLevel: boolean, showAllEnabled: boolean) => boolean;
    @Input('isShowAllEnabled') isShowAllEnabled: boolean = false;


    @Input('isMonthlyRevokeActive') isRevokeActive: boolean = false;
    @Input('isMonthlyReleaseActive') isReleaseActive: boolean = false;
    @Output() onClickReleaseMode: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() onClickRevokeMode: EventEmitter<boolean> = new EventEmitter<boolean>();

    FY1: string | undefined;
    currentFY: string | undefined;

    columnsToDisplay = ['arrow', 'Account', 'KpiName', 'KpiOwner', 'KpiUnit', 'LocalCurrency', 'AvailabilityTime', 'ReportingType', 'actions'];
    columnsToDisplay2 = ['ItemNo', 'COL1', 'COL2', 'COL3', 'COL4', 'ACTPY', 'ACTBUD', 'YTDACT', 'PYBUD', 'FY1BUD', 'P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'P7', 'P8', 'P9', 'P10', 'P11', 'P12', 'actions']
    public dataSource: MatTableDataSource<KpiManagement>;

    expandedElements = new Set();
    isAllCollapsed = false;
    Filter = 0;

    updatedItems: KpiManagementUpdate[] = []
    clickedItems: string[] = [];


    releaseList: selectedReleaseRow[] = []
    selection = new SelectionModel<UserSummary>(true, []);
    protected _onDestroy = new Subject<void>();
    selectedKpiOwner: string = '';
    selectedKpiUnit: string = '';
    kpiOwnerOptions: string[] = [];
    kpiUnitOptions: string[] = [];
    private originalData: KpiManagement[] = [];
    constructor(
        private dialogService: DialogService
        , @Inject('BASE_URL') private baseUrl: string
        , private dialogForm: MatDialog
        , private defaults: DefaultValuesService
    ) {
        this.dataSource = new MatTableDataSource<KpiManagement>();
        this.getFiscalYearHeaders()
    }
    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }

    ngOnChanges(changes: any) {
        if (changes.list) {
            this.getFiscalYearHeaders();
            this.dataSource.data = Utils.deepCopyArray(this.list)
            this.originalData = [...this.list]; // Store original data for filtering
            this.applyFilters(); // Apply initial filters
            this.setFilterOptions();
            this.expandedElements.clear()
            this.updatedItems = [];
            this.list.forEach(item => {
                if (item.AccountID === "MRYMID3005") { // Exception for account with AccountID "MRYMID3005"
                    item.DecimalDigits = 3;
                    if (item.KpiDetail) {
                        item.KpiDetail.forEach(detail => {
                            detail.DecimalDigits = 3;
                        });
                    }
                }
            });
        }

        if (changes.filter || changes.inclusiveFilter || changes.selectorFilter) {
            this.dataSource.filter = this.filter;
        }

        if (changes.isApprovalModeEnabled) {
            this.expandedElements.clear()
            this.updatedItems = []
        }
    }

    ngOnInit() {
        this.dialogService.tthis = this;
        this.dataSource.filterPredicate = (data: KpiManagement, filters: string) => {
            const filterList = filters ? filters.split('+').map(f => f.trim()).filter(f => f) : [];
            filterList.pop();
            
            if (filterList.length === 0) {
                
                    this.createMatSubtable(data);
                    data.subtable.filter = '__FORCE__';
                
                return true;
            }
            
           return FilterUtils.applyCommonFilterLogic(
                data,
                filterList,
                this.dataSource,
                this.auxFilterPredicate.bind(this),
                this.createMatSubtable.bind(this),
                this.isShowAllEnabled
            );     
        };

        this.dataSource.data = Utils.deepCopyArray(this.list)
        this.dataSource.filter = this.filter;
        this.setFilterOptions();
    }

    
    splitFilter(filter: string): string[] {
        const filterList = filter ? filter.split('+').map(f => f.trim()).filter(f => f) : [];
        filterList.pop();
        return filterList;
    }

    checkExpanded(element) {
        return this.expandedElements.has(element.AccountID);
    }

    pushPopElement(element) {
        if (this.expandedElements.has(element.AccountID)) {
            this.expandedElements.delete(element.AccountID);
        }
        else {
            this.expandElement(element.AccountID)
            if (!element.subtable) {
                this.createMatSubtable(element)
            }
        }
    }

    collapseOrExpandAll() {
        if (this.isAllCollapsed === false) {
            this.isAllCollapsed = true;
            this.dataSource.data.forEach((el: any) => {
                if (!this.expandedElements.has(el)) {
                    if (!el.subtable) {
                        this.createMatSubtable(el)
                    }
                    this.expandElement(el.AccountID)
                }
            })
        }
        else {
            this.isAllCollapsed = false;
            this.expandedElements.clear()
        }
    }

    private createMatSubtable(el: any) {
        let dataSource = new MatTableDataSource<any>();
        dataSource.data = el.KpiDetail
        dataSource.filterPredicate = (data2: any, filters: string) => {
            return this.auxFilterPredicate(filters, data2, false, this.isShowAllEnabled)
        }
        el.subtable = dataSource
    }

    private expandElement(el: any) {
        this.expandedElements.add(el);
    }

    onChange(account: any, breakdown: any, $e: any, field: string) {
        let field_value = $e !== null && $e !== undefined ? this.truncateDecimals(parseFloat($e), account.DecimalDigits).toFixed(account.DecimalDigits) : '0';

        /* Wait a sec. If we are editing a month in a YTD kpi defined BUDGET, value to update  
         * is the difference from the original to the new. */

        // We need to update both updated and next one in order to keep consistency between values
        let nextField = ''
        let nextFieldValue = ''

        let decimalDigits = breakdown.AccountID === "MRYMID3005" ? 3 : account.DecimalDigits; // Exception for account with AccountID "MRYMID3005"

        if (account.ReportingType == "YTD" && field.startsWith("P")) {
            switch (field) {
                case "P1": {
                    nextField = 'P2';
                    nextFieldValue = this.truncateDecimals(breakdown.P2 - Number.parseFloat(field_value), decimalDigits).toFixed(decimalDigits);
                    break;
                }
                case "P2": {
                    field_value = this.truncateDecimals(Number.parseFloat(field_value) - breakdown.P1, decimalDigits).toFixed(decimalDigits);
                    if (breakdown.P2.toString().split('.')[1]?.length > decimalDigits) {
                        breakdown.P2 = this.getBreakdownPeriodValue(breakdown.P1, field_value, decimalDigits);
                    }
                    nextField = 'P3';
                    nextFieldValue = this.truncateDecimals(breakdown.P3 - breakdown.P2, decimalDigits).toFixed(decimalDigits); break;
                }
                case "P3": {
                    field_value = this.truncateDecimals(Number.parseFloat(field_value) - breakdown.P2, decimalDigits).toFixed(decimalDigits);
                    if (breakdown.P3.toString().split('.')[1]?.length > decimalDigits) {
                        breakdown.P3 = this.getBreakdownPeriodValue(breakdown.P2, field_value, decimalDigits);
                    }
                    nextField = 'P4';
                    nextFieldValue = this.truncateDecimals(breakdown.P4 - breakdown.P3, decimalDigits).toFixed(decimalDigits); break;
                }
                case "P4": {
                    field_value = this.truncateDecimals(Number.parseFloat(field_value) - breakdown.P3, decimalDigits).toFixed(decimalDigits);
                    if (breakdown.P4.toString().split('.')[1]?.length > decimalDigits) {
                        breakdown.P4 = this.getBreakdownPeriodValue(breakdown.P3, field_value, decimalDigits);
                    }
                    nextField = 'P5';
                    nextFieldValue = this.truncateDecimals(breakdown.P5 - breakdown.P4, decimalDigits).toFixed(decimalDigits); break;
                }
                case "P5": {
                    field_value = this.truncateDecimals(Number.parseFloat(field_value) - breakdown.P4, decimalDigits).toFixed(decimalDigits);
                    if (breakdown.P5.toString().split('.')[1]?.length > decimalDigits) {
                        breakdown.P5 = this.getBreakdownPeriodValue(breakdown.P4, field_value, decimalDigits);
                    }
                    nextField = 'P6';
                    nextFieldValue = this.truncateDecimals(breakdown.P6 - breakdown.P5, decimalDigits).toFixed(decimalDigits); break;
                }
                case "P6": {
                    field_value = this.truncateDecimals(Number.parseFloat(field_value) - breakdown.P5, decimalDigits).toFixed(decimalDigits);
                    if (breakdown.P6.toString().split('.')[1]?.length > decimalDigits) {
                        breakdown.P6 = this.getBreakdownPeriodValue(breakdown.P5, field_value, decimalDigits);
                    }
                    nextField = 'P7';
                    nextFieldValue = this.truncateDecimals(breakdown.P7 - breakdown.P6, decimalDigits).toFixed(decimalDigits); break;
                }
                case "P7": {
                    field_value = this.truncateDecimals(Number.parseFloat(field_value) - breakdown.P6, decimalDigits).toFixed(decimalDigits);
                    if (breakdown.P7.toString().split('.')[1]?.length > decimalDigits) {
                    breakdown.P7 = this.getBreakdownPeriodValue(breakdown.P6, field_value, decimalDigits);
                    }
                    nextField = 'P8';
                    nextFieldValue = this.truncateDecimals(breakdown.P8 - breakdown.P7, decimalDigits).toFixed(decimalDigits); break;
                }
                case "P8": {
                    field_value = this.truncateDecimals(Number.parseFloat(field_value) - breakdown.P7, decimalDigits).toFixed(decimalDigits);
                    if (breakdown.P8.toString().split('.')[1]?.length > decimalDigits) {
                        breakdown.P8 = this.getBreakdownPeriodValue(breakdown.P7, field_value, decimalDigits);
                    }
                    nextField = 'P9';
                    nextFieldValue = this.truncateDecimals(breakdown.P9 - breakdown.P8, decimalDigits).toFixed(decimalDigits); break;
                }
                case "P9": {
                    field_value = this.truncateDecimals(Number.parseFloat(field_value) - breakdown.P8, decimalDigits).toFixed(decimalDigits);
                    if (breakdown.P9.toString().split('.')[1]?.length > decimalDigits) {
                        breakdown.P9 = this.getBreakdownPeriodValue(breakdown.P8, field_value, decimalDigits);
                    }
                    nextField = 'P10';
                    nextFieldValue = this.truncateDecimals(breakdown.P10 - breakdown.P9, decimalDigits).toFixed(decimalDigits); break;
                }
                case "P10": {
                    field_value = this.truncateDecimals(Number.parseFloat(field_value) - breakdown.P9, decimalDigits).toFixed(decimalDigits);
                    if (breakdown.P10.toString().split('.')[1]?.length > decimalDigits) {
                        breakdown.P10 = this.getBreakdownPeriodValue(breakdown.P9, field_value, decimalDigits);
                    }
                    nextField = 'P11';
                    nextFieldValue = this.truncateDecimals(breakdown.P11 - breakdown.P10, decimalDigits).toFixed(decimalDigits); break;
                }
                case "P11": {
                    field_value = this.truncateDecimals(Number.parseFloat(field_value) - breakdown.P10, decimalDigits).toFixed(decimalDigits);
                    if (breakdown.P11.toString().split('.')[1]?.length > decimalDigits) {
                        breakdown.P11 = this.getBreakdownPeriodValue(breakdown.P10, field_value, decimalDigits);
                    }
                    nextField = 'P12';
                    nextFieldValue = this.truncateDecimals(breakdown.P12 - breakdown.P11, decimalDigits).toFixed(decimalDigits); break;
                }
                case "P12": {
                    field_value = this.truncateDecimals(Number.parseFloat(field_value) - breakdown.P11, decimalDigits).toFixed(decimalDigits);
                    if (breakdown.P12.toString().split('.')[1]?.length > decimalDigits) {
                        breakdown.P12 = this.getBreakdownPeriodValue(breakdown.P11, field_value, decimalDigits);
                    }
                    break;
                }
            }
        }
        let updatedValue: KpiManagementUpdate = {
            'KpiId': breakdown.KpiId,
            'KpiMovementTypeId': breakdown.KpiMovementTypeId,
            'KpiProductHierarchyId': breakdown.KpiProductHierarchyId,
            'KpiVersion': 'BUDGET',
            'KpiDefinitionId': account.KpiDefinitionId,
            'KpiBreakdown1Id': breakdown.KpiBreakdown1Id,
            'KpiBreakdown2Id': breakdown.KpiBreakdown2Id,
            'KpiValue': field_value,
            'Field': field,
            'FY1BUD': breakdown.FY1BUD,
            'ReportingType': account.ReportingType,
            'SumMonthlyValues': account.ReportingType === 'YTD' ? breakdown.P12 : this.sumAllMonthValues(breakdown),
            ApprovalStatus: breakdown.ApprovalStatus,
            prev_FYFC: 0,
            KpiUnit: account.KpiUnit,
            DecimalDigits: account.DecimalDigits,
            auxFYFC: '0',
            IsAccumulative: false,
            AccountId: account.AccountID
        }

        this.addUpdatedItem(updatedValue);
        if (nextField !== '') {
            let nextValue: KpiManagementUpdate = {
                'KpiId': breakdown.KpiId,
                'KpiMovementTypeId': breakdown.KpiMovementTypeId,
                'KpiProductHierarchyId': breakdown.KpiProductHierarchyId,
                'KpiVersion': 'BUDGET',
                'KpiDefinitionId': account.KpiDefinitionId,
                'KpiBreakdown1Id': breakdown.KpiBreakdown1Id,
                'KpiBreakdown2Id': breakdown.KpiBreakdown2Id,
                'KpiValue': nextFieldValue,
                'Field': nextField,
                'FY1BUD': breakdown.FY1BUD,
                'ReportingType': account.ReportingType,
                'SumMonthlyValues': account.ReportingType === 'YTD' ? breakdown.P12 : this.sumAllMonthValues(breakdown),
                ApprovalStatus: breakdown.ApprovalStatus,
                prev_FYFC: 0,
                KpiUnit: account.KpiUnit,
                DecimalDigits: account.DecimalDigits,
                auxFYFC: '0',
                IsAccumulative: false,
                AccountId: account.AccountID


            }
            this.addUpdatedItem(nextValue);
        }
    }

    private getBreakdownPeriodValue(previousBreakdownValue: string, field_value: string | number, decimalDigits?: number) {
        const firstValue = Number.parseFloat(previousBreakdownValue);
        const secondValue = typeof field_value === 'string' ? Number.parseFloat(field_value) : field_value;
        const total = firstValue + secondValue;
        const digits = decimalDigits ?? 2;
        return Number(total.toFixed(digits));
    }

    private addUpdatedItem(newObject: KpiManagementUpdate) {
        const index = this.updatedItems.findIndex(
            (obj) =>
                obj.KpiDefinitionId === newObject.KpiDefinitionId &&
                obj.KpiBreakdown1Id === newObject.KpiBreakdown1Id &&
                obj.KpiBreakdown2Id === newObject.KpiBreakdown2Id &&
                obj.KpiId === newObject.KpiId &&
                obj.KpiVersion === newObject.KpiVersion &&
                obj.KpiMovementTypeId === newObject.KpiMovementTypeId &&
                obj.KpiProductHierarchyId === newObject.KpiProductHierarchyId &&
                obj.Field === newObject.Field
        );

        if (index !== -1) {
            this.updatedItems[index] = newObject;
        } else {
            this.updatedItems.push(newObject);
        }
    }

    private sumAllMonthValues(subelement: any): number {
        return parseFloat(subelement.P1) + parseFloat(subelement.P2) + parseFloat(subelement.P3) + parseFloat(subelement.P4) + parseFloat(subelement.P5)
            + parseFloat(subelement.P6) + parseFloat(subelement.P7) + parseFloat(subelement.P8) + parseFloat(subelement.P9) + parseFloat(subelement.P10)
            + parseFloat(subelement.P11) + parseFloat(subelement.P12)
    }


    formatCurrency(value, decimalDigits): string {
        if (value == undefined)
            return '';
        else
            return parseFloat(value).toLocaleString('de', { maximumFractionDigits: decimalDigits });
    }

    onClickItem(item: string) {
        this.clickedItems.push(item)
    }

    isItemClicked(item: any) {
        return this.clickedItems.findIndex(x => x === item.KpiDefinitionId + item.Granularity) >= 0
    }


    onDetail(element: any) {

        /*
        const Dialog = this.dialogForm.open(KpiDetailFormComponent, {
            panelClass: 'custom-mat-dialog',
            disableClose: false,
            data: { "KpiDefinitionId": element.KpiDefinitionId }
        });
        Dialog.afterClosed().subscribe(result => {
        });
*/
        var KpiId = "null";

        // Truko
        //KpiId = '206288';


        if (element.KpiId != undefined)
            KpiId = element.KpiId;

        const Dialog = this.dialogForm.open(KpiDetailFormComponent, {
            panelClass: 'custom-mat-dialog',
            disableClose: false,
            data: {
                "KpiDefinitionId": element.KpiDefinitionId,
                "KpiId": KpiId,
                "KpiBreakDown1Id": element.KpiBreakDown1Id,
                "KpiBreakDown2Id": element.KpiBreakDown2Id,
                "KpiMovementTypeId": element.KpiBreakDown2Id,
                "KpiPorductHierarchyId": element.KpiPorductHierarchyId,
                "DataType": 'BUDM'
            }
        });
        Dialog.afterClosed().subscribe(() => {
        });




    }

    private getFiscalYearHeaders() {
        this.FY1 = (this.defaults.fiscalYear).toString() + '-' + (this.defaults.fiscalYear + 1).toString();
        this.currentFY = (this.defaults.fiscalYear - 1).toString() + '-' + (this.defaults.fiscalYear).toString();
    }

    disableArrowKeys(event: KeyboardEvent) {
        if (
            event.key === 'ArrowUp' ||
            event.key === 'ArrowDown'
        ) {
            event.preventDefault();
        }
    }


    mapReleaseRow(row) {
        var selectedReleaseRow: selectedReleaseRow = {
            KpiDefinitionId: row.KpiDefinitionId,
            KpiMovementTypeId: row.KpiMovementTypeId,
            KpiProductHierarchyId: row.KpiProductHierarchyId,
            KpiBreakdown1Id: row.KpiBreakdown1Id,
            KpiBreakdown2Id: row.KpiBreakdown2Id

        };
        return selectedReleaseRow;
    }

    accountCheckboxCheck(row) {
        var Checked = row.KpiDetail.every((row) => {
            var mappedRow = this.mapReleaseRow(row);
            return this.releaseList.some((object) => this.objectsEqual(mappedRow, object));
        })
        return Checked
    }

    accountItemsIndetermine(row) {
        var Indeterminate = this.releaseList.some((selected) => (selected.KpiDefinitionId === row.KpiDefinitionId))
        return Indeterminate;
    }
    accountItemsDisable(row) {
        //console.log(row)
        var Disable = !row.KpiDetail.some((item) => {
            return (this.isReleaseActive ? (item.ApprovalStatus == "PRE-RELEASED") :
                (item.ApprovalStatus == "RELEASED"))
        }
        )
        return Disable;
    }

    accountItemsSelected(ischecked, row) {
        row.KpiDetail.forEach((item) => {
            this.isReleaseActive ? (item.ApprovalStatus == "PRE-RELEASED" ? this.expandedItemSelected(ischecked, item) : null) :
                (item.ApprovalStatus == "RELEASED" ? this.expandedItemSelected(ischecked, item) : null)
        });

    }
    expandedItemSelected(ischecked, row) {

        if ((this.isReleaseActive || this.isRevokeActive) && (this.isReleaseActive ? (row.ApprovalStatus == 'PRE-RELEASED') : (row.ApprovalStatus == 'RELEASED'))) {
            var selectedReleaseRow = this.mapReleaseRow(row);

            if (ischecked) {
                this.selection.select(row)
                this.onSelect(selectedReleaseRow);
            } else {
                this.selection.deselect(row)
                this.onDeselect(selectedReleaseRow);
            }
        }

    }
    onSelect(selectedReleaseRow) {
        //this.releaseList.push(selectedReleaseRow)

        //An extra layer of protection to not to add already selected rows (Implemented but not active)
        if (!this.releaseList.some((object) => this.objectsEqual(object, selectedReleaseRow))) {
            this.releaseList.push(selectedReleaseRow)
        }

    }
    onDeselect(selectedReleaseRow) {
        var mappedRow = this.mapReleaseRow(selectedReleaseRow)
        const index = this.releaseList.findIndex((object) => this.objectsEqual(mappedRow, object));
        if (index !== -1) {
            this.releaseList.splice(index, 1);
        }
    }

    objectsEqual(object1, object2) {
        if (object1 === object2) {
            return true;
        }
        if (Object.keys(object1).length !== Object.keys(object2).length) {
            return false;
        }
        for (const property in object1) {
            if (object1[property] !== object2[property]) {
                return false;
            }
        }
        return true;
    }
    getSelectionList() {
        return this.releaseList;
    }
    clearSelectionList() {
        this.releaseList = [];
        this.selection?.clear();
    }
    onClickReleaseMode_emitter(yearly: boolean) {
        this.onClickReleaseMode.emit(yearly);
    }
    onClickRevokeMode_emitter(yearly: boolean) {
        this.onClickRevokeMode.emit(yearly);
    }
    anyActionableItemExist() {
        return this.isReleaseActive ?
            this.list.some((kpi) => kpi.KpiDetail.some((kpidef) => (kpidef.ApprovalStatus == "PRE-RELEASED"))) :
            this.list.some((kpi) => kpi.KpiDetail.some((kpidef) => (kpidef.ApprovalStatus == "RELEASED")))
    }
    textRelRevbuttonState() {
        return this.anyActionableItemExist() ?
            (((this.isReleaseActive || this.isRevokeActive && this.isReleaseActive) ? 'Release ' : 'Revoke ') + (!this.selection.hasValue() ? 'All' : 'Selected')) :
            (this.isReleaseActive ? 'Nothing to Release' : 'Nothing to Revoke')
    }

    applyFilters() {
        this.dataSource.data = this.originalData.filter(item =>
            (this.selectedKpiOwner ? item.KpiOwner === this.selectedKpiOwner : true) &&
            (this.selectedKpiUnit ? item.KpiUnit === this.selectedKpiUnit : true)
        );
    }

    private setFilterOptions() {
        const data = this.list || [];
        this.kpiOwnerOptions = Array.from(new Set(data.map(item => item.KpiOwner).filter(x => !!x)));
        this.kpiUnitOptions = Array.from(new Set(data.map(item => item.KpiUnit).filter(x => !!x)));
    }
}
export interface SearchItem {
    name: string;
}
